<template>
  <div>

    <span v-if="name == 'SVIP'">
      <img src="@/assets/img/SVIP.svg" alt="">
    </span>
    <span v-else-if="name == '定额会员' || name == '付费会员'">
      <img src="@/assets/img/dinge.svg" alt="">
    </span>
    <span v-else-if="name == '潜力客户'">
      <img src="@/assets/img/qianli.svg" alt="">
    </span>
    <span v-else>({{ name }})</span>

  </div>
</template>
<script>
export default {
  props: ['name'],
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
img {
  max-height: 24px !important;

}
</style>